import _stafetCommonStepsProps from 'foundation/js/configurations/_stafetCommonStepsProps'
import FormInputTextField from '../FormInputTextField/FormInputTextField.vue'
import FormCheckbox from '../FormCheckbox/FormCheckbox.vue'
import StafetActions from '../StafetActions/StafetActions.vue'
import StafetPayment from '../StafetPayment/StafetPayment.vue'
import { onBeforeMount, ref, computed } from 'vue'
import fieldsConfig from './config/fieldsConfig'
import fieldValidator from 'foundation/js/stafet/fieldValidator'
import sessionStorageIdentifierEnum from 'foundation/js/sessionStorageWrapper/sessionStorageIdentifierEnum'
import getItemFromStorage from 'foundation/js/sessionStorageWrapper/getItemFromStorage'
import { useStore } from 'vuex'
import getFieldValue from 'foundation/js/stafet/getFieldValue'

export default {
    name: 'StafetDeltagPaaHoldStepFour',
    components: {
        FormInputTextField,
        FormCheckbox,
        StafetActions,
        StafetPayment
    },
    props: _stafetCommonStepsProps,
    setup(props) {
        const store = useStore()
        const firstTimeFighter = ref(false)
        const firstName = ref('')
        const lastName = ref('')
        const email = ref('')
        const phone = ref('')
        const consent = ref(false)
        const newsletter = ref(false)
        const fighterNewsletter = ref(false)
        const readOnly = ref({
            firstName: false,
            lastName: false,
            email: false,
            phone: false
        })

        const disableValidation = (fieldName) => {
            const field = fieldsConfig.find(field => field.name === fieldName)
            field.validator = _ => true
        }

        const basket = computed(() => {
            return store.state.stafet.basket
        })

        const basketTotalPrice = computed(() => {
            return store.state.stafet.basketTotalPrice
        })

        const isFighter = computed(() => {
            const userInputs = store.state.stafet.userInputs
            return userInputs.find((input) => input.name === 'isFighter')?.value
        })

        onBeforeMount(() => {
            
            if (props.userData) {
                
                if (props.userData.firstName) {
                    firstName.value = props.userData.firstName
                    readOnly.value.firstName = true
                    disableValidation('firstName')
                }
                
                if (props.userData.lastName) {
                    lastName.value = props.userData.lastName
                    readOnly.value.lastName = true
                    disableValidation('lastName')
                }
                
                if (props.userData.email) {
                    email.value = props.userData.email
                    readOnly.value.email = true
                    disableValidation('email')
                }
                
                if (props.userData.phoneNumber) {
                    phone.value = props.userData.phoneNumber
                    readOnly.value.phone = true
                    disableValidation('phone')
                }
            }
            
            const storedFields = getItemFromStorage(
                sessionStorageIdentifierEnum.STAFET_JOIN_A_TEAM
            )

            if (storedFields) {
                updateLocalRefs([
                    {
                        name: 'firstTimeFighter',
                        value: 
                            getFieldValue(storedFields, 'firstTimeFighter') ??
                            firstTimeFighter.value
                    },
                    {
                        name: 'firstName',
                        value:
                            getFieldValue(storedFields, 'firstName') ??
                            firstName.value
                        },
                    {
                        name: 'lastName',
                        value:
                            getFieldValue(storedFields, 'lastName') ??
                            lastName.value
                    },
                    {
                        name: 'email',
                        value:
                        getFieldValue(storedFields, 'email') ?? email.value
                    },
                    {
                        name: 'phone',
                        value:
                            getFieldValue(storedFields, 'phone') ?? phone.value
                    },
                    {
                        name: 'consent',
                        value:
                        getFieldValue(storedFields, 'consent') ??
                        consent.value
                    },
                    {
                        name: 'newsletter',
                        value:
                        getFieldValue(storedFields, 'newsletter') ??
                        newsletter.value
                    },
                    {
                        name: 'fighterNewsletter',
                        value:
                        getFieldValue(storedFields, 'fighterNewsletter') ??
                        fighterNewsletter.value
                    }
                ])
            }
        })

        const updateLocalRefs = (fields) => {
            fields.forEach((field) => {
                if (field.value === undefined || field.value === null) return
                fieldsConfig.find((item) => item.name === field.name).value = field.value
                switch (field.name) {
                    case 'firstTimeFighter':
                        firstTimeFighter.value = field.value
                        return
                    case 'firstName':
                        firstName.value = field.value
                        return
                    case 'lastName':
                        lastName.value = field.value
                        return
                    case 'email':
                        email.value = field.value
                        return
                    case 'phone':
                        phone.value = field.value
                        return
                    case 'consent':
                        consent.value = field.value
                        return
                    case 'newsletter':
                        newsletter.value = field.value
                        return
                    case 'fighterNewsletter':
                        fighterNewsletter.value = field.value
                        return
                    default:
                        return
                }
            })
        }

        const validateField = (fieldName, value) => {
            fieldsConfig.find((item) => item.name === fieldName).value = value
            const field = fieldsConfig.find((field) => field.name === fieldName)
            if (field) {
                field.value = value
                fieldValidator(field)
            }
        }

        const setFirstTimeFighter = (value) => {
            firstTimeFighter.value = value
            validateField('firstTimeFighter', value)
        }

        const setConsent = (value) => {
            consent.value = value
            validateField('consent', value)
        }

        const showFirstNameErrorMessage = computed(() => showError('firstName', firstName.value))
        const showLastNameErrorMessage = computed(() => showError('lastName', lastName.value))
        const showEmailErrorMessage = computed(() => showError('email', email.value))
        const showPhoneErrorMessage = computed(() => showError('phone', phone.value))
        const showError = (fieldName, value) => {
            const field = fieldsConfig.find(field => field.name === fieldName)
            return !field.validator(value) && props.displayInputError
        }

        const showConsentErrorMessage = computed(() => {
            return consent.value === false && props.displayInputError
        })

        const stepModel = computed(() => {
            return fieldsConfig
        })

        return {
            firstTimeFighter,
            firstName,
            lastName,
            email,
            phone,
            consent,
            newsletter,
            fighterNewsletter,
            readOnly,
            stepModel,
            basket,
            isFighter,
            basketTotalPrice,
            validateField,
            setFirstTimeFighter,
            setConsent,
            showFirstNameErrorMessage,
            showLastNameErrorMessage,
            showPhoneErrorMessage,
            showEmailErrorMessage,
            showConsentErrorMessage
        }
    }
}
